import React from 'react';
import { Box, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import BigQueryDatasetSelector from 'components/bigquery/BigQueryDatasetSelector';
import BigQueryTableSelector from 'components/bigquery/BigQueryTableSelector';
import ViewTableInBigQueryButton from 'components/bigquery/ViewTableInBigQueryButton';

const ListCutterJobSelectData = ({ 
  projectId, 
  sourceDataset, 
  onSelectDataset, 
  sourceTable, 
  onSelectTable,
  sourceVoterfileType,
  onSelectDataSourceType,
  isCatalistEnabled,
  isTargetsmartEnabled
}) => {

  return (
    <Box>
      {/* First, show the dataset selector */}
      <BigQueryDatasetSelector
        selectedDataset={sourceDataset}
        onSelectDataset={onSelectDataset}
        label="Select source dataset"
        title="Choose Data Source"
      />
      
      {/* Then, show the table selector if a dataset is selected */}
      {sourceDataset && (
        <Box>
          <BigQueryTableSelector
            datasetId={sourceDataset}
            selectedTable={sourceTable}
            onSelectTable={onSelectTable}
            label="Select source table"
          />
          
          {/* Add ViewTableInBigQueryButton, only visible if a table is selected */}
          {sourceTable && (
            <Box sx={{ mt: 2 }}>
              <ViewTableInBigQueryButton
                projectId={projectId}
                datasetId={sourceDataset}
                tableId={sourceTable}
                buttonText="View in BigQuery"
                variant="outlined"
                color="primary"
                size="medium"
                sx={{ mt: 1 }}
              />
            </Box>
          )}
        </Box>
      )}
      
      {/* TODO: add this back in when we implement default exclusions for voterfile data sources (and probably clean up the copy so users aren't confused about why this exists)
      {(isCatalistEnabled || isTargetsmartEnabled) && ( // This form only appears if either Catalist or TargetSmart is enabled for the project
        <FormControl component="fieldset" sx={{ mb: 3 }}>
          <FormLabel component="legend">Data Source Type (this is optional, but will help us help YOU)</FormLabel>
          <RadioGroup
            row
            value={sourceVoterfileType}
            onChange={(e) => onSelectDataSourceType(e.target.value)}
            sx={{ gap: 2 }}
          >
            {isCatalistEnabled && (
              <FormControlLabel value="catalist" control={<Radio />} label="Catalist" />
            )}
            {isTargetsmartEnabled && (
              <FormControlLabel value="targetsmart" control={<Radio />} label="Targetsmart" />
            )}
            <FormControlLabel value="other" control={<Radio />} label="Other" />
          </RadioGroup>
        </FormControl>
      )}
      */}
    </Box>
  );
};

export default ListCutterJobSelectData;